'use client';

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import ThemeSwitcher from './ThemeSwitcher';

const Sidebar = ({ open, onClose, items, user, onLogout, adminMode = false }) => {
  const location = useLocation();

  const handleThemeSwitcherContainerClick = () => {
    const ThemeSwitcherToggle = document.querySelector('.theme-switcher-container button');
    ThemeSwitcherToggle.click(); 
  }

  return (
    <>
      {/* Overlay pour fermer la sidebar en mode mobile */}
      {open && <div className="sidebar-overlay" onClick={onClose}></div>}

      <aside className={`sidebar ${open ? 'open' : ''} ${adminMode ? 'sidebar-admin' : ''}`}>
        <div className="sidebar-header">
          <div className="logo">
            <img src="/logo.png" alt="Alphafusion File Manager" />
            {/*<h2>Alphafusion File Manager</h2>*/}
          </div>
          <button className="close-sidebar" onClick={onClose}>
            <i className="material-icons">close</i>
          </button>
        </div>

        <div className="sidebar-user">
          <div className="user-avatar">
            {user?.firstName?.[0]}{user?.lastName?.[0]}
          </div>
          <div className="user-info">
            <h3>{user?.firstName} {user?.lastName}</h3>
          </div>
          <div className="user-meta">
            <p>{user?.email}</p>
            <span className="user-role">{user?.role === 'admin' ? 'Administrateur' : 'Utilisateur'}</span>
          </div>
        </div>

        <nav className="sidebar-nav">
          <ul>
            {items.map((item, index) => (
              <li key={index}>
                <Link 
                  to={item.path} 
                  className={`sidebar-link ${location.pathname === item.path ? 'active' : ''}`}
                  onClick={onClose}
                >
                  <i className="material-icons">{item.icon}</i>
                  <span>{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="sidebar-footer">
          <div className="theme-switcher-container" onClick={handleThemeSwitcherContainerClick}>
            <ThemeSwitcher />
            <span>Changer de thème</span>
          </div>
          <button className="logout-button" onClick={onLogout}>
            <i className="material-icons">logout</i>
            <span>Déconnexion</span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;